import { ActiveQuests } from '@/components/ActiveQuests';
import { useTranslation } from 'react-i18next';

export default function Quests() {
  const { t } = useTranslation();
  return (
    <>
      <section className="section pb-0">
        <div className="container-narrow text-center mb-8">
          <h1 className="font-pixel text-5xl font-bold tracking-tight">{t('quests_page.title')}</h1>
          <p className="mt-4 text-kquest-300 text-lg max-w-2xl mx-auto">{t('quests_page.subtitle')}</p>
        </div>
      </section>
      <ActiveQuests />
    </>
  );
}
